/* Homepage sliders. No product templates or global theme objects are modified. */
(function () {
  'use strict';
  if (!document.body.classList.contains('template-index')) return;
  var libraryPromise;
  var sliders = new Map();
  function library() {
    if (window.Flickity) return Promise.resolve(window.Flickity);
    if (!libraryPromise) {
      libraryPromise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = 'https://unpkg.com/flickity@2.3.0/dist/flickity.pkgd.min.js';
        script.onload = function () {
          if (window.Flickity) resolve(window.Flickity);
          else reject(new Error('Flickity unavailable'));
        };
        script.onerror = reject;
        document.head.appendChild(script);
      }).catch(function (error) { libraryPromise = null; throw error; });
    }
    return libraryPromise;
  }
  function init(root) {
    var elements = root.querySelectorAll('[data-hs-logo-slider], [data-hs-testimonial-slider]');
    if (!elements.length) return;
    library().then(function (Flickity) {
      elements.forEach(function (el) {
        if (!el.isConnected || sliders.has(el)) return;
        var isLogo = el.hasAttribute('data-hs-logo-slider');
        var options = isLogo ? {
          cellSelector: '.logo-bar__item-custom', cellAlign: 'left', contain: true,
          wrapAround: true, groupCells: true, pageDots: true,
          prevNextButtons: true, autoPlay: 4000, pauseAutoPlayOnHover: true
        } : {
          cellSelector: '.testimonials-slides', cellAlign: 'left', contain: true,
          wrapAround: false, groupCells: true, pageDots: true,
          prevNextButtons: false, adaptiveHeight: true, accessibility: true
        };
        var slider = Flickity.data(el) || new Flickity(el, options);
        sliders.set(el, slider);
        var resize = function () { if (el.isConnected) slider.resize(); };
        el.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) img.addEventListener('load', resize, { once: true });
        });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(resize);
        resize();
      });
    }).catch(function () {
      // CSS keeps every item accessible by horizontal scrolling if the CDN is unavailable.
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    sliders.forEach(function (slider, el) {
      if (event.target.contains(el)) { slider.destroy(); sliders.delete(el); }
    });
  });
}());
